import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NotAllowedAfterLogin } from './core/guards/not-allowed-after-login.guard';
import { NotAllowedBeforeLogin } from './core/guards/not-allowed-before-login.guard';

const routes: Routes = [
  {
    path: 'login',
    canActivate: [NotAllowedAfterLogin],
    pathMatch: 'full',
    loadChildren: () => import('./pages/common/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'auth',
    canActivate: [NotAllowedBeforeLogin],
    loadChildren: () =>
      import('./pages/common/after-login/after-login.module').then((m) => m.AfterLoginModule),
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
